import React, { useEffect, useState } from "react";
import Carousel from "./Carousel";
import Health from "./Health";
import Tips from "./Tips";
import Technology from "./Technology";
import Education from "./Education";
import LatestEducation from "./asides/LatestEducation";
import TopNews from "./asides/TopNews";
import Tags from "./asides/Tags";
import PopularPost from "./asides/PopularPost";
import { Button } from "@material-tailwind/react";
import StayConnected from "./asides/StayConnected";
import { Link } from "react-router-dom";
import axios from "axios";

interface Fish {
  id: number;
  name: string;
  avatar: string;
  description: string;
}

const MovieTrailer: React.FC = () => {
  const [Fishes, setFishes] = useState<Fish[]>([]);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: '',
    avatar: '',
    attachment: null as File | null,
    description: null as string | null,
  });

  useEffect(() => {
    const fetchFishesData = async () => {
      try {
        const response = await fetch("https://localhost:7246/api/Fishes");
        const data = await response.json();
        setFishes(data.result);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching fishes data:", error);
        setLoading(false);
      }
    };

    fetchFishesData();
  }, []);

  
  const [submissionStatus, setSubmissionStatus] = useState<string | null>(null);

  const handleChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('name', formData.name);
      formDataToSend.append('avatar', formData.avatar);
      formDataToSend.append('attachment', formData.attachment as File);
      formDataToSend.append('description', formData.description || '');

      const response = await axios.post('https://localhost:7246/api/Subscribes', formDataToSend, {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log('Post response:', response.data);

      // Handle success or update state accordingly
      setSubmissionStatus('subscribed successfully!');
    } catch (error) {
      console.error('Error posting data:', error);
      // Handle error
      setSubmissionStatus('Error Subscription. Please try again.');
    }
  };

  const closePopup = () => {
    setSubmissionStatus(null);
  };


  return (
    <div className="max-w-inner mx-auto">
      <div>
        <div className="bg-white py-5 md:px-12 px-4 flex">
          <h2 className="font-semibold capitalize text-xl md:text-3xl relative">
            <span>Latest Movie Trailer</span>
            <div className="absolute -bottom-4 left-0 h-[6px] w-full bg-secondary"></div>
          </h2>
        </div>
        <div className="grid md:grid-cols-4 md:gap-4 gap-2 mt-6 mb-3">
          {loading ? (
            <p>Loading fish data...</p>
          ) : (
            Fishes.map((fish) => (
              <div key={fish.id} className="col-span-1 relative">
                <img className="h-full w-full" src={`https://localhost:7246/${fish.avatar}`} alt={`avatar-${fish.id}`} />
                <div className="absolute bottom-6 leading-6 left-0 capitalize text-sm px-7 text-white">
                  <Link className="absolute bottom-6 leading-6 left-0 capitalize text-sm px-7 text-white" to={fish.name}>
                    {fish.name}
                  </Link>
                </div>
                <div className="w-[33px] h-[33px] absolute right-8 top-5">
                  {/* Add your icon/image here */}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      <div className="grid md:grid-cols-12 grid-cols-1 gap-4">
        <div className="md:col-span-9">
          <Carousel />
          <Health />
          <Tips />
          <div className="md:px-14 px-4 relative md:py-8 py-4 bg-white rounded-sm">
            <img src="/blog/tips-add.png" alt="" className="w-full h-full" />
            <div className="absolute left-0 top-0 w-full h-full flex items-center justify-center md:text-3xl">
              Ads
            </div>
          </div>
          <Technology />
          <Education />
        </div>
        <div className="md:col-span-3">
          <aside className="flex justify-center flex-col">
            <div className=" bg-white p-4 mx-auto">
              <img
                src="/blog/add-red.png"
                alt=""
                className="w-[252.24px] h-[207.3]"
              />
            </div>
            <LatestEducation />
            <TopNews />
            <Tags />
            <PopularPost />
            <div className="bg-white px-6 py-10 mt-12">
              <div className="flex flex-col items-center justify-center gap-4">
                <div className="w-[32px] h-[29px] ">
                  <img src="/blog/fly.png" alt="" />
                </div>
                <h2 className="text-xl font-semibold text-center">
                  Subscribe to Our Newsletter
                </h2>
                <form onSubmit={handleSubmit}>
                  <div className="flex flex-col gap-3">
                    <div className="max-w-full">
                      <input
                        type="email" name="name" value={formData.name} onChange={handleChange}
                        placeholder="Enter Email Address"
                        className="border-2 py-3 pl-8 pr-10 w-full placeholder:text-gray-700 placeholder:text-sm"
                      />
                    </div>
                    <Button type="submit"  className="bg-red-600 w-full rounded-none capitalize">
                      Subscribe
                    </Button>
                  </div>
                </form>
                {/* Submission status popup */}
                {submissionStatus && (
                  <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', padding: '20px', background: 'white', borderRadius: '8px', boxShadow: '0 0 10px rgba(0, 0, 0, 0.3)', zIndex: 9999 }}>
                    <p>{submissionStatus}</p>
                    <button onClick={closePopup} style={{ padding: '8px 16px', background: '#4CAF50', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Close</button>
                  </div>
                )}
                <p className="text-xs w-full text-center">
                  Don't worry, we won't spam
                </p>
              </div>
            </div>
            <StayConnected />
          </aside>
        </div>
      </div>
    </div>
  );
};

export default MovieTrailer;
